import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'


function Coupons() {

    const { couponId } = useParams()

    const [coupon, setCoupon] = useState({
        companyName: '',
        couponCode: `${couponId}`,
        validityDate: '',
        discountOff: '',
        terms: '',
        location: ''
      });

      const [ noCouponMsg, setNoCouponMsg] = useState(false)
      const [ checking, setChecking ] = useState(false)


    const checkForCoupon = async() => {
        try {
            setChecking(true)
            const response = await axios.get('https://mokurenserver.onrender.com/refercoupons', {params: { couponId }})
            if(response.status === 201){
                setCoupon(response.data)
                setChecking(false)
                return
            } else{
               setNoCouponMsg(true)
               setChecking(false)
               return
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        checkForCoupon()
    }, [])

  return (
    <div className='coupon-container'>
        { noCouponMsg && !checking && <div className="coupon-card">
            <h3>Mokuren</h3>
            <p>申し訳ありませんが、参照リンクは無効または既に期限切れのようです....</p>
            <p>インターネット接続が原因である可能性もありますので、しばらくお待ちください。</p>
        </div>}
        { !noCouponMsg && checking && <div className="coupon-card">
            <h3>Mokuren</h3>
            <p>クーポンコード「{couponId}」を確認しています。</p>
            <p>時間がかかった場合は、遅れて申し訳ありません。ページを更新してみてください。</p>
        </div>}
       { !noCouponMsg && !checking && <div className="coupon-card">
            <div className="couponInfo">
                <p className='company-name'>{coupon.companyName}</p>
                <p>REFERRAL</p>
                <h2>COUPON</h2>
                <h1>{coupon.couponCode}</h1>
                <p className='validTill'>{String(new Date(coupon.validityDate)).slice(0,15)}まで有効 !!</p>
            </div>
            <div className="couponImage">
                <div className="ribbon">
                    <h1>{coupon.discountOff}</h1>
                </div>
            </div>
            <small>規約と条件: {coupon.terms}</small>
            <p>店の場所: {coupon.location}</p>
            <p className='ourLogo'>Mokuren Inc.</p>
        </div>}
    </div>
  )
}

export default Coupons